module.exports = {"TXTCLI_Back":{"id":"TXTCLI_Back","defaultMessage":"Назад","flags":["TRACK"],"track":"Back"}}